import { render, staticRenderFns } from "./draw3DLineCanvas3item.vue?vue&type=template&id=72bb7e2c&scoped=true&"
import script from "./draw3DLineCanvas3item.vue?vue&type=script&lang=js&"
export * from "./draw3DLineCanvas3item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb7e2c",
  null
  
)

export default component.exports